import * as React from 'react';

import axios from 'axios';

import {
  Colors,
} from '@bluecurrent/web-component-lib';

import YAxis from './components/YAxis';
import XAxis from './components/XAxis';
import Chart from './components/Chart';
import Price from './components/Price';
import Separators from './components/Separators';
import Spacing from './components/Spacing';

import DefaultData from './data/DefaultData';

export default function Graph({
  width,
  type,
  chart,
  hasVat,
}) {
  const [data, setData] = React.useState(DefaultData);
  const [isLoading, setLoading] = React.useState(true);

  React.useEffect(() => {
    axios.get(
      `${process.env.API_MIDDLEWARE_URL}/v1/${type}/prices/public?included=${chart === 'market' ? 'N' : 'Y'}`,
    )
      .then((response) => {
        const DATA = response.data.items.map((item, index) => {
          const hour = item.hour % 24;
          const formattedHour = hour < 10 ? `0${hour}` : `${hour}`;

          if (['00', '06', '12', '18'].includes(formattedHour)) {
            return [
              {
                id: index * 100,
                type: 'divider',
              },
              {
                id: item.id,
                amount: hasVat ? item.amount_in_vat : item.amount_ex_vat,
                amount_currency: item.amount_currency,
                hour: formattedHour,
                day: item.day,
              },
            ];
          }

          return {
            id: item.id,
            amount: hasVat ? item.amount_in_vat : item.amount_ex_vat,
            amount_currency: item.amount_currency,
            hour: formattedHour,
            day: item.day,
          };
        }).flat();

        setData(DATA);
        setLoading(false);
      })
      .catch((e) => console.log(e));
  }, [type, chart, hasVat]);

  return (
    <div
      style={{
        height: 500,
        width,
        borderRadius: 10,
        backgroundColor: Colors.WHITE,
        border: `solid 2px ${Colors.MEDIUM_WHITE}`,
        boxShadow: 'rgba(136, 136, 141, 0.15) 0px 2px 8px',
        overflow: 'hidden',
        display: 'grid',
        gridTemplateColumns: '15px 1fr 85px',
        gridTemplateRows: '1fr',
        gridColumnGap: 0,
        gridRowGap: 0,
        position: 'relative',
      }}
    >
      <Spacing />
      <Separators />
      <Price
        data={data}
        isLoading={isLoading}
      />
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '1fr',
          gridTemplateRows: '436px 60px',
          gridColumnGap: 0,
          gridRowGap: 0,
          overflowX: 'scroll',
          overflowY: 'hidden',
          position: 'relative',
        }}
      >
        <div
          style={{
            width: '100%',
            minWidth: 550,
          }}
        >
          <Chart
            data={data}
            type={type}
            isLoading={isLoading}
          />
          <XAxis
            data={data}
          />
        </div>
      </div>
      <YAxis
        data={data}
        isLoading={isLoading}
      />
    </div>
  );
}
